import React, {useEffect, useState} from "react";
import {Button, Form} from "react-bulma-components";
import axios from "axios";
import {createSetDataFreshAction} from "../../../actions/dataActions";
import {useDispatch, useSelector} from "react-redux";
import {NotificationManager} from "react-notifications";


export default function RentalMarginRow({marginData, index, onUpdate, dataFresh}){
    const dispatch = useDispatch();
    const [margin, setMargin] = useState(marginData);
    const [editable, setEditable] = useState(false);

    const onEdit = e => {
        e.stopPropagation();
        setEditable(!editable);
    };

    const onChange = (e) => {
        let newRentalMargin = {...margin};
        newRentalMargin[e.target.name] = e.target.value || null;
        setMargin(newRentalMargin);
        onUpdate(index, newRentalMargin);
    }

    const submitUpdate = (e) => {
        e.stopPropagation();
        const conf = {
            method: "put",
            data: margin,
            url: "api/rentalmargin/"+margin.id
        }
        axios(conf).then(res => {
           setEditable(false);
           dispatch(createSetDataFreshAction(dataFresh + 1))
        })
    }

    const onDelete = () => {
        const conf = {
            method: "delete",
            url: "api/rentalmargin/"+margin.id
        }
        axios(conf).then(() => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            if(err){
                NotificationManager.error("There was an error");
            }
        })
    }

    return (
      <tr>
          <td>
              <Form.Field onClick={e => e.stopPropagation()} className="has-addons">
                  <Form.Control>
                      <Form.Input
                        type={"text"}
                        name={"name"}
                        value={margin.name}
                        disabled={!editable}
                        onChange={onChange}
                      />
                  </Form.Control>
                  {editable ? (
                    <Form.Control>
                        <Button color="success" onClick={submitUpdate}>
                            Save
                        </Button>
                    </Form.Control>
                  ) : (
                    <Form.Control>
                        <Button onClick={onEdit}>Edit</Button>
                    </Form.Control>
                  )}

              </Form.Field>
          </td>
          <td>
              <Form.Field onClick={e => e.stopPropagation()} className="has-addons">
                  <Form.Control>
                      <Form.Input
                        type={"text"}
                        name={"margin"}
                        value={margin.margin}
                        disabled={!editable}
                        onChange={onChange}
                      />
                  </Form.Control>
                  {editable ? (
                    <Form.Control>
                        <Button color="success" onClick={submitUpdate}>
                            Save
                        </Button>
                    </Form.Control>
                  ) : (
                    <Form.Control>
                        <Button onClick={onEdit}>Edit</Button>
                    </Form.Control>
                  )}

              </Form.Field>
          </td>
          <td>
              <Button
                color={"danger"}
                onClick={onDelete}
              >
                  Delete X
              </Button>
          </td>
      </tr>
    )

}